import { render, staticRenderFns } from "./tableCadastralOvamCustomers.vue?vue&type=template&id=0aaa138d&scoped=true"
import script from "./tableCadastralOvamCustomers.vue?vue&type=script&lang=js"
export * from "./tableCadastralOvamCustomers.vue?vue&type=script&lang=js"
import style0 from "./tableCadastralOvamCustomers.vue?vue&type=style&index=0&id=0aaa138d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa138d",
  null
  
)

export default component.exports